import './referralsource.css'
export default function AnalyticsReferralSource() {
  return (
    <div className="rp-analytics-referral-card">

      {/* TITLE */}
      <h3 className="rp-analytics-referral-title">
        Referral Source Mix
      </h3>

      {/* DONUT */}
      <div className="rp-analytics-donut-wrapper">
        <svg
          viewBox="0 0 36 36"
          className="rp-analytics-donut"
        >
          {/* BACKGROUND */}
          <circle
            className="rp-analytics-donut-bg"
            cx="18"
            cy="18"
            r="15.9"
          />

          {/* NETWORK 45% */}
          <circle
            className="rp-donut-network"
            cx="18"
            cy="18"
            r="15.9"
            strokeDasharray="45 55"
          />

          {/* SOCIAL 25% */}
          <circle
            className="rp-donut-social"
            cx="18"
            cy="18"
            r="15.9"
            strokeDasharray="25 75"
            strokeDashoffset="-45"
          />

          {/* REFERRAL 20% */}
          <circle
            className="rp-donut-referral"
            cx="18"
            cy="18"
            r="15.9"
            strokeDasharray="20 80"
            strokeDashoffset="-70"
          />

          {/* EVENTS 10% */}
          <circle
            className="rp-donut-events"
            cx="18"
            cy="18"
            r="15.9"
            strokeDasharray="10 90"
            strokeDashoffset="-90"
          />

          {/* CENTER TEXT */}
          <text
            x="18"
            y="17"
            textAnchor="middle"
            className="rp-analytics-donut-value"
          >
            100%
          </text>
          <text
            x="18"
            y="22"
            textAnchor="middle"
            className="rp-analytics-donut-label"
          >
            Sources
          </text>
        </svg>
      </div>

      {/* LEGEND */}
      <ul className="rp-analytics-referral-legend">
        <li>
          <span className="rp-dot rp-network"></span>
          <span>Network</span>
          <strong>45%</strong>
        </li>
        <li>
          <span className="rp-dot rp-social"></span>
          <span>Social</span>
          <strong>25%</strong>
        </li>
        <li>
          <span className="rp-dot rp-referral"></span>
          <span>Referral</span>
          <strong>20%</strong>
        </li>
        <li>
          <span className="rp-dot rp-events"></span>
          <span>Events</span>
          <strong>10%</strong>
        </li>
      </ul>

    </div>
  );
}
